"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "DIANA C.",
  quote: "\"PupzStudio transformed our digital presence into a regal showcase, attracting serious interest effortlessly.\"",
  position: "CKCS Breeder",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1453987/img/testimonial_jane_d.png"
}, {
  author: "Michael R.",
  quote: "Their Custom Website approach and attention to detail truly reflect the quality we strive for.",
  position: "Heritage Kennel Owner",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1453987/img/testimonial_michael_r.png"
}];
export default function ClientSuccessStories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="client-success-stories" className="bg-background py-24 md:py-32 overflow-hidden relative">
      <div ref={ref} className={`container mx-auto px-6 md:px-12 max-w-5xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <Carousel opts={{
        loop: true,
        align: "center"
      }} className="w-full">
          <CarouselContent>
            {testimonials.map((item, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center justify-center text-center px-4 md:px-16 py-8">
                  <div className="rounded-full border-2 border-ring p-1.5 mb-10 shadow-lg shadow-ring/10">
                    <SafeHydrate><Avatar className="size-24 md:size-32">
                      <AvatarImage src={item.image} alt={item.author} className="object-cover" />
                      <AvatarFallback className="font-serif text-2xl bg-muted text-muted-foreground">
                        {item.author.charAt(0)}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                  </div>

                  <blockquote className="mb-10 max-w-3xl">
                    <p className="font-serif text-2xl md:text-4xl lg:text-5xl italic text-foreground leading-relaxed md:leading-snug tracking-wide">
                      "{item.quote}"
                    </p>
                  </blockquote>

                  <div className="flex flex-col items-center space-y-2">
                    <cite className="font-sans font-bold text-ring tracking-widest uppercase text-sm md:text-base not-italic">
                      {item.author}
                    </cite>
                    <span className="font-sans text-muted-foreground text-sm md:text-base tracking-wide">
                      {item.position}
                    </span>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          <CarouselPrevious className="hidden md:flex border-ring text-ring hover:bg-ring hover:text-primary-foreground transition-colors size-12 -left-4 lg:-left-12" />
          <CarouselNext className="hidden md:flex border-ring text-ring hover:bg-ring hover:text-primary-foreground transition-colors size-12 -right-4 lg:-right-12" />
        </Carousel>
      </div>
    </section>;
}